import React from "react"

class SingleRoomSelect extends React.Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.initSelect2();
  }

  componentDidUpdate(prevProps) {
    if (this.props.room == null && prevProps.room != null && this.refs.room) {
      // reset the select
      $(this.refs.room).val('').trigger('change');
    }
  }

  initSelect2() {
    var self = this;
    if (this.refs.room) {
      $(this.refs.room).select2({
        ajax: {
          url: '/admin/rooms_remote',
          dataType: 'json',
          delay: 250,
          data: function (params) {
            return {
              q: params.term,
              page: params.page,
              results_per_page: 40,
              include_room_groups: true,
              room_type_id: self.props.room_type ? self.props.room_type.id : '',
              // reservation_segment_id: self.props.reservation_segment_id,
              source: self.props.source ? self.props.source : '',
              additional_params: self.props.AdditionalParams ? self.props.AdditionalParams : '',
            };
          },
          processResults: function (data, params) {
            params.page = params.page || 1;
            return {
              results: data.items,
              pagination: {
                more: (params.page * 40) < data.total_count
              }
            };
          },
          cache: false
        },
        allowClear: true,
        escapeMarkup: function (markup) {
          return markup;
        },
        placeholder: I18n.t('select_ellipsis'),
        templateResult: function (room) {
          return self.selectedOption(room);
        },
        templateSelection: function (room) {
          return self.selectedOption(room);
        }
      }).on('select2:unselect', function () {
        self.props.onChange(null);
      }).on('select2:select', function(selection) {
        self.props.onChange(selection.params.data);
      });
    }
  }

  render() {
    return (
      <div className="room">
        <select className="form-control" ref="room" style={{width: '100%', minHeight: 33}}>
          {this.props.room ? <option onChange={(room) => this.props.onChange(this.props.room)} value={this.props.room.id}>{this.renderRoomDetails(this.props.room)}  </option> : null}
        </select>
        {this.renderFieldError()}
      </div>
    );
  }

  selectedOption(room) {
    if (room.identifier) {
      return `<span>${room.identifier} (${room.room_type_name ? room.room_type_name : I18n.t('none').italics()}) ${room.disabled ? '(' + I18n.t('occupied_for_dates') + ')' : ''}</span>`
    } else {
      return room.text
    };
  };

  renderRoomDetails(room) {
    var self = this;
    
    if (room && room.id != null && room.id != '' && room.identifier) {
      return(
        room.identifier + ' (' + (room.room_type_name ? room.room_type_name : I18n.t('none').italics()) + ') '
      )
    } else {
      return room.text;
    }
  }

  renderFieldError() {
    if(this.props.hasError){
      if (this.props.hasError.includes('has-errors')) {  
        if ($(".room").find('.select2-container--default .select2-selection--single .select2-selection__rendered')[0] && !$(".room").find('.select2-container--default .select2-selection--single .select2-selection__rendered')[0].className.includes('has-errors')) {
          $(".room").find('.select2-container--default .select2-selection--single .select2-selection__rendered')[0].className += this.props.hasError
        }
      }
      if (this.props.hasError == "no error") {
        if ($(".room").find('.select2-container--default .select2-selection--single .select2-selection__rendered')[0] && $(".room").find('.select2-container--default .select2-selection--single .select2-selection__rendered')[0].className.includes('has-errors')) {
          var select = $(".room").find('.select2-container--default .select2-selection--single .select2-selection__rendered')[0]
          select.className = select.className.replace(/has-errors/g, "")
        }
      }
    };
  }

};

export default SingleRoomSelect